var map = {
	"./collection_incomplete.svg": 1687,
	"./material_incomplete.svg": 3646,
	"./product_incomplete.svg": 721,
	"./scene_incomplete.svg": 357,
	"./space_incomplete.svg": 857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1831;